import FoodAmigosLogo from '../../assets/images/FoodAmigosLogo.png';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { Stringable } from '../../services/helpers/Stringable';
import useStorefrontColors from '../../modules/storefront/hooks/useStorefrontColors';
import useStorefront from '../../hooks/storefront/useStorefront';

export default function PoweredByFooter() {
  const { company } = useSelector((state: StoreInterface) => state.initialData);
  const website = new Stringable(company?.service_provider?.website).start('https://').toString();
  const { store } = useStorefront();
  const { getColor } = useStorefrontColors();

  const backgroundColor = store && getColor(store.theme.footer_props.bottom_bar_background_color);
  const textColor = store && getColor(store.theme.footer_props.bottom_bar_text_color);

  return (
    <div
      className="border-t border-brand-border py-lg flex lg:flex-row flex-col justify-center items-center relative mt-lg gap-3"
      style={{
        backgroundColor,
      }}
    >
      <p className="text-xs text-brand-text-secondary font-medium" style={{ color: textColor }}>
        © {new Date().getFullYear()} All Rights Reserved
      </p>
      <a
        className="flex justify-center items-center p-xs rounded-full border border-brand-border gap-x-xs lg:absolute relative lg:right-[70px]"
        href={website}
        target={'_blank'}
        rel="noreferrer"
      >
        <p className="text-xs text-brand-text-secondary font-medium" style={{ color: textColor }}>
          Made with {company?.service_provider?.name ?? 'FoodAmigos'} 💚
        </p>
        <img src={company?.service_provider?.logo_url ?? FoodAmigosLogo} alt="FoodAmigosLogo" className="h-[12px]" />
      </a>
    </div>
  );
}
